/**
 * Shared terminal phase for `discovery-only` protocol journeys (Meta,
 * Mistral, Apple, DuckDuckGo) — per ADR-0159 §3:
 *
 *   > terminal "reads, cites, leaves — no checkout to authorize" phase
 *   > INSIDE the PhaseTimeline (founder decision — a terminal phase, not
 *   > a footer card).
 *
 * The phase keeps the timeline honest at the end: the journey completes
 * without a mandate, cart, or payment. Kept in its own file (not
 * `discovery.ts`) so the timeline builders in `discovery.ts` stay free of
 * per-protocol content.
 */

import type { AgentDef } from '../roster.js';
import type { Phase } from './types.js';

export function buildDiscoveryOnlyTerminalPhase(agent: AgentDef): Phase {
  return {
    id: 'discovery-terminal',
    name: 'Reads, cites, leaves',
    tier: 'illustration',
    narration:
      `${agent.name} reads your published catalog, may cite it to its user, and leaves. There's no checkout to authorize — no mandate, no cart, no payment.`,
    endpoint: {
      method: 'GET',
      path: '(no further request)',
      status: 200,
      ms: 0,
      body: '{ "outcome": "read + cite + leave" }',
      live: false,
    },
    ok: true,
  };
}
